import React from 'react';
import { Sidebar } from '../components/Sidebar';
import { Header } from '../components/Header';
import { SparklesIcon, ClockIcon, TrendingUpIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function DealerDashboard() {
  const navigate = useNavigate();
  return <div className="flex w-full min-h-screen bg-gray-50" data-id="element-1739">
      <Sidebar data-id="element-1740" />
      <main className="flex-1" data-id="element-1741">
        <Header data-id="element-1742" />
        <div className="px-6 py-8" data-id="element-1743">
          <div className="max-w-4xl mx-auto" data-id="element-1744">
            <h1 className="text-3xl font-semibold text-gray-800 mb-2" data-id="element-1745">
              Dealerization Flow
            </h1>
            <p className="text-gray-600 mb-8" data-id="element-1746">
              AI-Powered Creative Resizing & Campaign Generation
            </p>

            <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-1747">
              <StatCard icon={<SparklesIcon className="text-blue-500" size={24} data-id="element-1749" />} title="99% Time Saved" subtitle="From 7 weeks to 35 minutes" data-id="element-1748" />
              <StatCard icon={<ClockIcon className="text-green-500" size={24} data-id="element-1751" />} title="35 Minutes" subtitle="Complete workflow time" data-id="element-1750" />
              <StatCard icon={<TrendingUpIcon className="text-purple-500" size={24} data-id="element-1753" />} title="500+ Creatives" subtitle="Generated automatically" data-id="element-1752" />
            </div>

            <div className="bg-white rounded-lg border border-gray-200 p-8 shadow-sm" data-id="element-1754">
              <h2 className="text-xl font-medium text-gray-800 mb-4" data-id="element-1755">
                Workflow Overview
              </h2>
              <div className="space-y-4 mb-6" data-id="element-1756">
                <WorkflowStep number="0" title="Master Creative Editing" time="3-5 mins" description="Upload and AI-resize creatives for multiple formats" data-id="element-1757" />
                <WorkflowStep number="1" title="Campaign Setup" time="2 mins" description="Select dealers and set campaign parameters" data-id="element-1758" />
                <WorkflowStep number="2" title="Select Master Creative" time="1 min" description="Choose from library with format mapping" data-id="element-1759" />
                <WorkflowStep number="3" title="Styling Template" time="5 mins" description="Create or apply dynamic field templates" data-id="element-1760" />
                <WorkflowStep number="4" title="Variable Content" time="3 mins" description="Fill pricing, offers, and festival text" data-id="element-1761" />
                <WorkflowStep number="5" title="Generate Creatives" time="5-10 mins" description="Auto-generate dealer-specific creatives" data-id="element-1762" />
                <WorkflowStep number="6" title="Review & Publish" time="5 mins" description="Review gallery and publish campaigns" data-id="element-1763" />
              </div>

              <button onClick={() => navigate('/dealerization/step-0')} className="w-full bg-blue-500 text-white px-6 py-3 rounded-md font-medium hover:bg-blue-600 transition-colors" data-id="element-1764">
                Start New Dealerization Campaign
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>;
}
function StatCard({
  icon,
  title,
  subtitle
}) {
  return <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm" data-id="element-1765">
      <div className="flex items-start mb-3" data-id="element-1766">{icon}</div>
      <div className="text-2xl font-semibold mb-1" data-id="element-1767">{title}</div>
      <div className="text-gray-500 text-sm" data-id="element-1768">{subtitle}</div>
    </div>;
}
function WorkflowStep({
  number,
  title,
  time,
  description
}) {
  return <div className="flex items-start" data-id="element-1769">
      <div className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-medium mr-4 flex-shrink-0" data-id="element-1770">
        {number}
      </div>
      <div className="flex-1" data-id="element-1771">
        <div className="flex items-center justify-between mb-1" data-id="element-1772">
          <h3 className="font-medium text-gray-800" data-id="element-1773">{title}</h3>
          <span className="text-sm text-gray-500" data-id="element-1774">⏱️ {time}</span>
        </div>
        <p className="text-sm text-gray-600" data-id="element-1775">{description}</p>
      </div>
    </div>;
}